<template>
<v-container class="home">
  <v-layout row wrap reverse mb-5 justify-space-between>
    <v-flex class="feeling-select" xs12 sm12 md4 lg3 order-xs2 order-md1>
      <v-card d-flex>
        <v-card-title class="feeling-card-title" primary-title>
          <div class="card-content">
            <h3 class="card-title">How are you feeling?</h3>
            <v-divider />
            <div class="mood-select-container">
              <v-select
                :items="moods"
                :label="lastMood ? lastMood.text : 'How are we feeling today?'"
                @change="updateMood"
                class="mood-select"
                ref="mood"
                return-object
                clearable
                solo
              ></v-select>
            </div>
            <div>
              <v-sparkline
                v-if="moodline && moodline.length > 1"
                :value="moodline"
                :line-width="3"
                :radius="5"
                :gradient="['#3CE8E8', '#8974AD', '#D2097A']"
                :type="sparklineMode || 'trend'"
                auto-draw
                smooth
                :fill="fillSparklines"
              />
                <!--:gradient="['#3CE8E8', '#8974AD', '#D2097A']"-->
            </div>
          </div>
        </v-card-title>
      </v-card>
      <v-card v-if="activeTimers && activeTimers.length > 0" class="timer-box">
        <v-card-title  primary-title>
          <div class="card-content">
            <h3 class="card-title">You have active timers</h3>
            <v-divider />
              <v-layout v-for="item in activeTimers" :key="item.date + item.id" row align-center justify-space-between class="timer-row">
              <div class="task-date" @click="setDateFilter(item.date)">{{ item.date }}</div>
              <div class="task-name text-truncate" @click="setDateFilter(item.date)">{{ item.name || 'unnamed task' }}</div>
                <div class="task-time">{{ time(curTime, item) }}</div>
                <v-btn flat small fab @click="trackTime(item)" class="task-timer-btn">
                  <v-icon>timer_off</v-icon>
                </v-btn>
              </v-layout>
          </div>
          </v-card-title>
      </v-card>
      <v-card v-if="upcomingTasks && displayUpcomingBox" class="upcoming-tasks-box">
        <v-card-title  primary-title>
          <div class="card-content">
            <h3 class="card-title">There's some stuff on the horizon</h3>
            <v-divider />
              <v-layout v-for="list, d in upcomingTasks" :key="'upcoming-' + d" column align-start justify-start mb-2 class="">
              <h4 @click="setDateFilter(d)">{{ d }}</h4>
                <v-layout v-for="task in list" :key="'t-' + task.id" row grow align-baseline justify-space-between class="upcoming-tasks-row" @click="setDateFilter(d)">
                  <div>{{ task.name || 'unnamed task' }}</div>
                  <v-chip v-if="task.children && task.children.length > 0" small label color="secondary" text-color="white">{{ task.children.length }} Items</v-chip>
                  <v-chip v-else small label color="primary" text-color="white">Task</v-chip>
                </v-layout>
              </v-layout>
            </div>
          </v-card-title>
      </v-card>
    </v-flex>
    <v-flex xs12 sm12 md7 lg8 order-xs1 order md2 mb-5>
      <v-card>
        <v-card-title primary-title>
          <div class="tree-container">
          <v-layout justify-space-between align-baseline>
            <v-btn fab flat small @click="prevDay" class="date-nav-btn prev">
              <v-icon>navigate_before</v-icon>
            </v-btn>
            <h3 class="headline datefilter">{{ dateFilter }}</h3>
            <div class="datefilter-stats" v-if="filteredLog && filteredLog.length > 0">
              <v-chip small label>{{ filteredLog.length }} Items</v-chip>
              <v-chip small label v-if="displayTimers && logTimers[dateFilter]">{{ logTimers[dateFilter] | duration }}</v-chip>
              <v-icon v-if="displayRatings && logRatings[dateFilter]">{{ logRatings[dateFilter].moodAverage | moodIcon }}</v-icon>
            </div>
            <v-btn fab flat small @click="nextDay" class="date-nav-btn next">
              <v-icon>navigate_next</v-icon>
            </v-btn>
          </v-layout>
            <v-divider />
            <div class="tree-comp-container">
              <v-treeview
                v-if="nestedLogs && nestedLogs.length > 0"
                :items="nestedLogs"
                :open="opened"
                open-all
                ref="tree"
                transition
              >
                <template v-slot:label="{ item, open, active }">
                  <v-hover>
                    <v-container pa-0 px-2 slot-scope="{ hover }" :ref="'item-container-' + item.id" @mouseover="hovering = item.id" :class="(hovering === item.id && dragging) ? 'hovering' : ''" @dragenter.prevent.stop @dragover.prevent @drop.prevent="handleDrop(item, $event)">
                      <v-layout row wrap align-center justify-start class="tree-node-layout">
                        <v-flex shrink :data-id="item.id" :data-parent-id="item.parent_id">
                          <v-combobox
                            v-if="editing === item.id"
                            placeholder="Backspace again to delete"
                            :items="autoCompleteTasks"
                            :value="item.name"
                            @change="applyItemName(item.id, $refs.input.$refs.input.value)"
                            :return-object="false"
                            ref="input"
                            @keyup.shift.enter="addChild(item)"
                            @keyup.ctrl.enter="addSibling(item)"
                            @keyup.alt.enter="startLog"
                            @keyup.enter="editing = (editing === item.id) ? null : editing"
                            @keyup.delete="flagItemForRemoval($refs.input.$refs.input.value, item)"
                            @click:append-outer="applyItemName(item.id, $refs.input.$refs.input.value), editing = null"
                            hide-no-data
                            solo
                            hide-details
                            auto-focus
                            append-outer-icon="done"
                          >
                            <template v-slot:prepend>
                            </template>
                          </v-combobox>
                          <!-- @click:append-outer="item.name = $refs.input.$refs.input.value, editing = null" -->
                          <div v-else @click="toggleEdit(item)" class="node-text">
                            <VueMarkdown :html="false" :source="item.name || 'Click to add task description'"></VueMarkdown>
                          </div>
                        </v-flex>
                        <v-flex v-if="hover || editing === item.id || alwaysDisplayTaskTools || item.startTime" class="btn-group" >
                          <v-btn flat icon small>
                            <v-icon @mousedown.prevent="startDrag(item)" class="btn tree drag">open_with</v-icon>
                          </v-btn>
                          <v-btn flat icon small>
                            <v-icon @click="removeLogEntry(item)" class="btn tree">delete_forever</v-icon>
                          </v-btn>
                          <v-btn flat icon small>
                            <v-icon @click="addChild(item)" class="btn tree">subdirectory_arrow_right</v-icon>
                          </v-btn>
                          <v-btn flat icon small>
                            <v-icon @click="addSibling(item)" class="btn tree">arrow_downward</v-icon>
                          </v-btn>
                          <template v-if="displayTimers || item.startTime">
                            <v-btn v-if="(!item.timers || item.timers.length === 0) && !item.startTime" flat icon small @click="trackTime(item)">
                              <v-icon class="btn tree">timer</v-icon>
                            </v-btn>
                            <v-chip v-else :color="item.startTime ? 'primary' : ''" :text-color="item.startTime ? 'white' : ''" @click="trackTime(item)">
                              <v-icon v-if="!item.startTime" left>timer</v-icon>
                              <v-icon v-else left>timer_off</v-icon>
                              <template v-if="item.startTime">
                                {{ time(curTime, item) }}
                              </template>
                              <template v-else>
                              {{ totalTime(item) }}
                              </template>
                            </v-chip>
                            <v-btn small flat icon :color="item.notes ? 'warning' : ''" @click="toggleItemNotes(item)">
                              <v-icon class="btn tree">notes</v-icon>
                            </v-btn>
                            <a v-if="displayGeolocation && item.location && item.location.coords" :href="'https://www.google.com/maps/place/' + item.location.coords.latitude + ',' + item.location.coords.longitude" class="location-link" target="_blank">
                              <v-btn flat icon small>
                                <v-icon>location_on</v-icon>
                              </v-btn>
                            </a>
                          </template>
                            <v-rating
                              v-if="displayRatings"
                              v-model="item.rating"
                              length="3"
                              clearable
                              @input="setItemRating(item)"
                              style="display: inline-block; position: absolute;"
                            />
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-hover>
                  <v-container pa-0 px-2 ml-2>
                    <v-layout column align-top wrap>
                      <v-flex v-if="displayTags" wrap>
                        <v-combobox
                          v-if="editing === item.id"
                          v-model="item.tags"
                          :items="defaultTags"
                          label="Tag this entry"
                          @change="setItemTags(item)"
                          small-chips
                          clearable
                          dense
                          multiple
                        >
                          <template v-slot:selection="data">
                            <v-chip
                              close
                              label
                              small
                              :color="data.item.color || 'light-blue'"
                              :text-color="data.item.textColor || 'white'"
                              @input="removeTag(item, data)"
                            >
                              <strong>{{ data.item.text || data.item }}</strong>
                            </v-chip>
                          </template>
                        </v-combobox>
                        <div v-else>
                          <v-chip
                            v-for="tag in item.tags"
                            close
                            label
                            small
                            :color="tag.color || 'light-blue'"
                            :text-color="tag.textColor || 'white'"
                            @input="removeTag(item, tag)"
                            :key="'tag-' + (tag.text || tag)"
                          >
                            <strong>{{ tag.text || tag }}</strong>
                          </v-chip>
                        </div>
                      </v-flex>
                      <v-flex v-if="showItemNotes[item.date + item.id]">
                        <v-card :color="dark ? 'grey darken-2' : 'grey lighten-4'" @dragenter.prevent.stop @dragover.prevent @drop.prevent="handleDrop(item, $event)">
                          <v-card-title primary-title>
                            <div class="headline">Notes</div>
                          </v-card-title>
                          <v-card-text>
                            <div v-if="!editItemNotes[item.date + item.id]" @click="toggleEditItemNotes(item)" class="markdown task-notes-container" :ref="'item-notes-' + item.id">
                                <VueMarkdown :html="false" :source="item.notes || 'Click to add some notes'" @rendered="markdownRendered(item.id)" />
                            </div>
                            <v-textarea
                              v-else
                              :value="item.notes || ''"
                              clearable
                              solo
                              auto-grow
                              label="Notes"
                              @input="applyItemNotes(item.id, $refs.taskNotes.$refs.input.value)"
                              @click:clear="clearItemNotes(item.id, $refs.taskNotes.$refs.input.value)"
                              @blur="toggleEditItemNotes(item)"
                              ref="taskNotes"
                            ></v-textarea>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn @click="copyToClipboard(item.notes)">Copy to Clipboard</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </template>
              </v-treeview>
              <div v-if="dragging && dragging.parent_id !== '0'" class="root-drop-zone" @mouseover="hovering = 0"></div>
              <v-alert v-if="nestedLogs && nestedLogs.length == 0" type="info" :value="true" outline>
                Nothing to see here, use the button to the right to add a task.
              </v-alert>
              <v-btn fab absolute bottom right dark color="pink" @click="startLog">
                <v-icon>add</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>
      </v-card>
      <v-card v-if="displayNotes" class="notes-box">
        <v-card-title  primary-title>
          <div class="card-content">
            <h3 class="card-title">Notes</h3>
            <v-divider />
            <div v-if="!editingNotes" @click="editNotes" class="markdown" ref="item-notes-daily">
              <VueMarkdown v-if="todaysNotes" :source="todaysNotes" @rendered="markdownRendered('daily')"/>
              <v-alert v-else type="info" :value="true" outline>Click here to take some notes</v-alert>
            </div>
            <v-textarea v-else outline clearable box ref="notes" label="Notes" :value="todaysNotes" auto-grow @input="saveCurNote" @blur="editingNotes = false"/>
          </div>
          </v-card-title>
      </v-card>
    </v-flex>
  </v-layout>
  <v-bottom-sheet v-model="sheet" inset>
    <template v-slot:activator>
      <v-btn
        color="purple"
        dark
        fab
        fixed
        bottom
        right
      >
        <v-icon>calendar_today</v-icon>
      </v-btn>
    </template>
    <v-layout column pa-2 class="calendar-container">
      <div class="calendar-headline">
        <v-layout wrap align-baseline justify-space-between>
          <v-btn small flat fab @click="$refs.calendar.prev()">
            <v-icon dark color="white">
              keyboard_arrow_left
            </v-icon>
          </v-btn>
          <h3 class="title bottom-bar-headline">Calendar</h3>
          <v-btn small flat fab @click="$refs.calendar.next()">
            <v-icon dark color="white">
              keyboard_arrow_right
            </v-icon>
          </v-btn>
        </v-layout>
        <v-divider/>
      </div>
      <v-calendar
        ref="calendar"
        v-model="calendar.start"
        :type="calendar.type"
        @click:date="(e) => setDateFilter(e.date)"
      >
        <template v-slot:day="{ present, past, future, date }">
          <template>
            <v-layout row wrap fill-height align-start justify-space-between class="hidden-sm-and-down">
              <v-flex v-if="!future && logs[date] && logs[date].length > 0 && displayRatings" xs12>
                <v-layout>
                  <v-rating
                    v-if="logRatings[date].rating > 0"
                    v-bind:value="logRatings[date].rating || 0"
                    length="3"
                    half-increments
                    small
                    readonly
                  />
                  <div v-else class="calendar-rating-placeholder">-</div>
                </v-layout>
              </v-flex>
              <v-flex v-if="!future && logRatings[date] && logRatings[date].mood && logRatings[date].mood.length > 1">
                <v-sparkline
                  :value="logRatings[date].mood"
                  :line-width="2"
                  :type="sparklineMode"
                  smooth
                  auto-draw
                  :gradient="['#3CE8E8', '#8974AD', '#D2097A']"
                  :fill="fillSparklines"
                />
              </v-flex>
              <v-layout align-self-end>
                <v-flex>
                  <v-chip v-if="logs[date] && logs[date].length > 0" label small color="primary" text-color="white">{{ logs[date].length }}</v-chip>
                </v-flex>
                <template v-if="!future">
                  <v-spacer />
                  <v-flex v-if="logRatings[date] && logRatings[date].moodAverage" text-right align-self-end>
                    <v-icon>{{ logRatings[date].moodAverage | moodIcon }}</v-icon>
                  </v-flex>
                </template>
              </v-layout>
            </v-layout>
            <v-chip v-if="logs[date] && logs[date].length > 0" small label color="primary" text-color="white" class="hidden-md-and-up">{{ logs[date].length }}</v-chip>
          </template>
        </template>
        <template v-slot:dayLabel="{ present, past, date, day }">
        <div class="marker">{{ day }}</div>
        <div v-if="displayTimers && logTimers[date]" class="hidden-sm-and-down">{{ logTimers[date] | duration }}</div>
        </template>
      </v-calendar>
    </v-layout>
  </v-bottom-sheet>
  <v-snackbar
    v-model="showSnackbar"
  >
    {{ snackbar }}
    <v-btn
      dark
      flat
      @click="showSnackbar = false"
    >
      Close
    </v-btn>
  </v-snackbar>
</v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';
import axios from 'axios';
import VueMarkdown from 'vue-markdown'
import Prism from 'prismjs';
import MsgReader from '@freiraum/msgreader'

export default {
  name: 'Home',
  components: {
    VueMarkdown
  },
  data() {
    return {
      editing: null,
      sheet: false,
      moods: [
        { value: -2, text: "Bad" },
        { value: -1, text: "Could be better" },
        { value: 0, text: "OK, I guess?" },
        { value: 1, text: "Good" },
        { value: 2, text: "Excellent!" }
      ],
      calendar: {
        type: 'month',
        types: ['month', 'week'],
        start: null,
      },
      defaultTags: [
        { text: "work", color: "purple", textColor: "white" },
        { text: "private", color: "orange", textColor: "white" },
        { text: "leisure", color: "green", textColor: "white" },
      ],
      selectedMood: null,
      curTime: null,
      timerId: null,
      editingNotes: false,
      showItemNotes: {},
      editItemNotes: {},
      hovering: null,
      dragging: false,
      snackbar: '',
      showSnackbar: false
    };
  },
  computed: {
    mood() {
      return this.moodLog[this.moodLog.length - 1];
    },
    opened() {
      return this.filteredLog.map(item => item.id);
    },
    moodline() {
      let result = [];
      if (this.moodLog.length > 0) {
        let others = this.moodLog.filter(item => item.timestamp.slice(0, 10) != new Date().toISOString().slice(0, 10)).map(item => item.value);  // use this to get the last entry as the starting point of the moodline
        result = this.moodLog.filter(item => item.timestamp.slice(0, 10) == new Date().toISOString().slice(0, 10)).map(item => item.value);
        if (others.length > 0) {
          result.unshift(others.pop());
        }
      }
      return result;
    },
    ...mapGetters([
      "lastMood",
      "nestedLogs",
      "dateFilter",
      "filteredLog",
      "logs",
      "logRatings",
      "logTimers",
      "moodLog",
      "dark",
      "displayTags",
      "displayTimers",
      "displayRatings",
      "sparklineMode",
      "fillSparklines",
      "alwaysDisplayTaskTools",
      "autoCompleteTasks",
      "activeTimers",
      "upcomingTasks",
      "displayUpcomingBox",
      "useGeolocation",
      "displayGeolocation",
      "todaysNotes",
      "displayNotes",
      "togglApiKey",
      "togglWorkspaceId",
      "togglIntegrationActive"
    ])
  },
  mounted() {
    let date = new Date().toISOString().slice(0, 10);
    this.setDateFilter(date);
    this.curTime = Date.now();
    this.timerId = setInterval(() => this.curTime = Date.now(), 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  filters: {
    moodIcon(value) {
      if(isNaN(value)) return '';
      if (value < -1) return 'sentiment_very_dissatisfied';
      if (value <= 0) return 'sentiment_dissatisfied';
      //if (value == 0) return '';
      if (value > 1) return 'sentiment_very_satisfied';
      if (value > 0) return 'sentiment_satisfied';
    },
    duration(duration) {
      var sec_num = parseInt(duration, 10); // don't forget the second param
      var hours   = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
      var seconds = sec_num - (hours * 3600) - (minutes * 60);

      if (hours   < 10) {hours   = "0"+hours;}
      if (minutes < 10) {minutes = "0"+minutes;}
      if (seconds < 10) {seconds = "0"+seconds;}
      return hours+':'+minutes+':'+seconds;
    }
  },
  methods: {
    async addChild(item) {
      let id = await this.addLogEntry({
        date: this.dateFilter,
        parentId: item.id
      });
      this.editing = id;
      let vm = this;
      this.$nextTick(() => {
        vm.$refs['input'].$refs.input.focus();
      });
    },
    async addSibling(item) {
      let id = await this.addLogEntry({
        date: this.dateFilter,
        parentId: item.parent_id
      });
      this.editing = id;
      let vm = this;
      this.$nextTick(() => {
        vm.$refs['input'].$refs.input.focus();
      });
    },
    cloneAsObject(obj) {
      if (obj === null || !(obj instanceof Object)) {
        return obj;
      }
      var temp = (obj instanceof Array) ? [] : {};
      for (var key in obj) {
        temp[key] = this.cloneAsObject(obj[key]);
      }
      return temp;
    },
    trackTime(item) {
      if (!item.hasOwnProperty('timers')) {
        item.timers = [];
      }
      if (!item.startTime) {
        item.startTime = Date.now();
        this.setItemStartTime(item);
      } else {
        let cur = Date.now();
        let duration = (cur - item.startTime) / 1000;
        let start = moment(item.startTime).format();
        let tags = item.tags.map(t => t.text);
        let data = {
          time_entry: {
            description: item.name,
            created_with: "LogBook",
            start: start,
            duration: duration,
            wid: this.togglWorkspaceId,
            tags: ['LogBook', ...tags ]
          }
        };
        if (this.togglIntegrationActive && this.togglApiKey != '' && this.togglWorkspaceId) {
          axios({
            method: 'post',
            url: 'https://www.toggl.com/api/v8/time_entries',
            data: data,
            auth: {
              password: 'api_token',
              username: this.togglApiKey
            }
          }).then(() => {
            this.snackbar = 'Timer saved to toggl.';
            this.showSnackbar = true;
          }).catch(error => {
            this.snackbar = 'Failed to save timer to toggl. Please check your configuration';
            this.showSnackbar = true;
          });
        }
        this.addItemTimer( { item: item, timer: {start: item.startTime, end: cur } });
        item.startTime = null;
        this.clearItemStartTime(item);
      }
    },
    getCurrentPosition() {
      let vm = this;
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition((loc) => {
          resolve(vm.cloneAsObject(loc));
        }, reject, {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        });
      });
    },
    flagItemForRemoval(value, item) {
      if (value == '' && item.name == '' && item.delete) {
        this.removeLogEntry(item);
        return;
      }
      if (value == '' && item.name == '') {
        item.delete = true;
      }
    },
    removeTag(item, tag) {
      item.tags.splice(item.tags.indexOf(tag), 1)
      item.tags = [...item.tags]
      this.setItemTags(item);
    },
    updateMood(value) {
      this.addMood({
        ...value,
        timestamp: new Date().toISOString()
      });
      this.$refs["mood"].reset();
    },
    toggleEdit(item) {
      this.editing = (this.editing === item.id) ? null : item.id;
      let vm = this;
      this.$nextTick(() => {
        vm.$refs['input'].$refs.input.focus();
      });
    },
    async startLog() {
      if (this.nestedLogs.length == 0) {
        let location = null;
        let vm = this;
        if (this.useGeolocation) {
          try {
            location = await this.getCurrentPosition();
          } catch(error) {
            location = null;
            this.snackbar = 'Failed to get location data';
            this.showSnackbar = true;
          }
        }
        let id = await this.addLogEntry({
          parentId: "0",
          date: this.dateFilter
        });
        this.editing = id;
        this.$nextTick(() => {
          vm.$refs['input'].$refs.input.focus();
        });
      } else {
        this.addSibling(this.nestedLogs[this.nestedLogs.length - 1]);
      }
    },
    durationString(duration) {
      var sec_num = parseInt(duration, 10); // don't forget the second param
      var hours   = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
      var seconds = sec_num - (hours * 3600) - (minutes * 60);

      if (hours   < 10) {hours   = "0"+hours;}
      if (minutes < 10) {minutes = "0"+minutes;}
      if (seconds < 10) {seconds = "0"+seconds;}
      return hours+':'+minutes+':'+seconds;
    },
    time(curTime, item) {
      if (!item.startTime) return '';
      curTime = curTime || Date.now();

      let duration = (curTime - item.startTime) / 1000;
      return this.durationString(duration);
    },
    totalTime(item) {
      if (!item.timers || item.timers.length < 1) return '';
      let total = 0;
      item.timers.forEach(timer => { total += timer.end - timer.start; });
      total = total / 1000;
      return this.durationString(total);
    },
    prevDay() {
      let cur = moment.utc(this.dateFilter);
      cur = cur.subtract(1, 'days').toISOString().slice(0, 10);
      this.setDateFilter(cur);
    },
    nextDay() {
      let cur = moment.utc(this.dateFilter);
      cur = cur.add(1, 'days').toISOString().slice(0, 10);
      this.setDateFilter(cur);
    },
    saveCurNote(notes) {
      this.saveNote({ date: this.dateFilter, notes });
    },
    editNotes() {
      this.editingNotes = true;
      this.$nextTick(() => this.$refs.notes.focus());
    },
    startDrag(item) {
      let e = window.event;
      e.preventDefault();

      this.dragging = item;
      let parent = this.$refs["item-container-" + item.id].closest('.v-treeview-node');
      document.body.style.position = 'relative';
      let node = parent.cloneNode(true);
      let prevDisplay = parent.style.display;
      parent.style.display = 'none';

      node.style.position = 'fixed';
      node.style.background = 'rgba(255, 255, 255, 0.8)';
      node.style.opacity = 0.7;
      node.style.border = '1px dashed gray';
      node.style.left = e.clientX + "px";
      node.style.top = e.clientY + "px";

      let mouseMove = function(e) {
        node.style.left = e.clientX + "px";
        node.style.top = e.clientY + "px";
      }
      document.addEventListener('mousemove', mouseMove);

      let vm = this;
      let mouseUp = function (e) {
        if (vm.hovering === 0 || (vm.hovering !== item.id && vm.hovering !== item.parent_id)) {
          let parentId = vm.hovering;
          item.parent_id = "" + parentId;
          vm.moveItem(item);
          document.removeEventListener('mouseup', mouseUp);
          node.remove();
          vm.dragging = false;
        } else {
          document.removeEventListener('mouseup', mouseUp);
          node.remove();
          vm.dragging = false;
        }
        parent.style.display = prevDisplay;
        parent.style
      }
      document.addEventListener('mouseup', mouseUp);
      document.body.append(node);

    },
    applyItemName(id, name) {
      this.setItemName({ date: this.dateFilter, id: id, name: name });
    },
    applyItemNotes(id, notes) {
      this.setItemNotes({ date: this.dateFilter, id: id, notes: notes});
    },
    clearItemNotes(id, value) {
      this.$refs.taskNotes.$refs.input.value = '';
    },
    toggleItemNotes(item) {
      let key = item.date + item.id;
      let next = (!this.showItemNotes.hasOwnProperty(key) || this.showItemNotes[key] === false) ? true : false;
      this.$set(this.showItemNotes, key, next);
    },
    toggleEditItemNotes(item) {
      let key = item.date + item.id;
      let next = (!this.editItemNotes.hasOwnProperty(key) || this.editItemNotes[key] === false) ? true : false;
      this.$set(this.editItemNotes, key, next);
      if (next) {
        let vm = this;
        this.$nextTick(() => {
          vm.$refs.taskNotes.$refs.input.focus();
        });
      }
    },
    copyToClipboard(value) {
      this.$copyText(value);
      this.snackbar = 'Copied to clipboard.';
      this.showSnackbar = true;
    },
    markdownRendered(id) {
      let vm = this;
      this.$nextTick(() => {
        Prism.highlightAllUnder(vm.$refs['item-notes-' + id]);
      });
    },
    handleDrop(item, e) {
      e.preventDefault();
      if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
        for(let i = 0; i < e.dataTransfer.files.length; i++) {
          let file = e.dataTransfer.files[i];
          let vm = this;
          let type = file.name.split('.').pop();
          if (type.toLowerCase() == 'msg') {
            let reader = new FileReader();
            reader.onload = (e) => { 
              try {
              let msg = new MsgReader(e.target.result)
              let content = msg.getFileData();
              let mailNote = '**Subject:** ' + content.subject + '\n';
              mailNote += '**From:** ' + content.senderName + '\n';
              let recipients = content.recipients.map(r => r.name);
              let atts = content.attachments.map(a => {
                return a.fileName + ' (' + vm.humanFileSize(a.contentLength) + ')';
              });
              mailNote += '**To:** ' + recipients.join(', ') + '\n';
              if (atts && atts.length > 0) mailNote += "**Attachments:** " + atts.join(', ') + '\n';
              mailNote += '\\';
              mailNote += '\n' + content.body.replace(/[\r\n]+/g, '\n');
              vm.appendItemNotes({ date: item.date, id: item.id, notes: mailNote });
              } catch (error) {
                console.error(error);
                vm.snackbar = 'Failed to get file contents';
                vm.showSnackbar = true;
              }
            };
            try {
              reader.readAsArrayBuffer(file);
            } catch (error) {
              console.error(error);
              this.snackbar = 'Failed to get file contents';
              this.showSnackbar = true;
            }
          } else {
            let prismKeys = Object.keys(Prism.languages);
            let validExtensions = [ 'php', 'sql', 'cpp', 'c', 'css' ];
            let extensions = prismKeys.concat(validExtensions);
            try {
              let reader = new FileReader();
              reader.onload = (e) => { 
                let note = e.target.result;
                if (extensions.includes(type)) note = '```' + type + '\n' + note + '\n```';
                vm.appendItemNotes({ date: item.date, id: item.id, notes: note });
              };
              reader.readAsText(file);
            } catch (error) {
              console.error(error);
              this.snackbar = 'Failed to get file contents';
              this.showSnackbar = true;
            }
          }
        }
      }
    },
    humanFileSize(bytes, si) {  // https://stackoverflow.com/a/14919494/1058055
      let thresh = si ? 1000 : 1024;
      if(Math.abs(bytes) < thresh) {
        return bytes + ' B';
      }
      let units = si
        ? ['kB','MB','GB','TB','PB','EB','ZB','YB']
        : ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];
      let u = -1;
      do {
        bytes /= thresh;
        ++u;
      } while(Math.abs(bytes) >= thresh && u < units.length - 1);
      return bytes.toFixed(1)+' '+units[u];
    },
    ...mapActions([
      "addMood",
      "addLogEntry",
      "removeLogEntry",
      "setDateFilter",
      "setItemTags",
      "setItemRating",
      "addItemTimer",
      "setItemStartTime",
      "clearItemStartTime",
      "setItemName",
      "setUseGeolocation",
      "saveNote",
      "setItemNotes",
      "appendItemNotes",
      "moveItem"
    ])
  }
}
</script>

<style lang="scss" scoped>
@import '../../node_modules/prismjs/themes/prism-okaidia.css';

.home {
  position: relative;
  z-index: 1;

  .node-text {

    &::v-deep p {
      margin: 0;
    }
  }

  &::v-deep .v-treeview-node__root {
    align-items: flex-start;
  }

  &::v-deep .text-right {
    text-align: right;
  }

  &::v-deep .v-treeview-node__root {
    position: relative;
    padding-left: 20px;

    .v-treeview-node__toggle {
      position: absolute;
      top: 5px;
      left: 0;
    }
  }

  .feeling-card-title {
    display: flex;
    flex-direction: column;
  }

  .datefilter {
    /*border-bottom: 2px solid white;*/
  }

  .tree-container {
    width: 100%;
  }

  .mood-select-container, .tree-comp-container {
    padding-top: 10px;
  }

  .tree-node-layout {
    min-height: 41px;
  }

  .datefilter-stats {
    display: flex;
    align-items: center;
  }

}
.calendar-container {
  height: 80vh;
}

.headline {
  margin-right: auto;
}

.calendar-headline {
  padding: 10px 0;
  .title {
    margin-bottom: 5px;
  }
}

.text-right {
  text-align: right;
}

.date-nav-btn {
  &.prev {
    margin-left: 0;
  }
  &.next {
    margin-right: 0;
  }
}


.card-content {
  width: 100%;

  h3 {
    font-size: 18px;
    text-transform: uppercase;
    font-weight: normal;
  }
}

.notes-box {
  margin-top: 30px;
}

.timer-box {
  margin-top: 30px;
  align-items: baseline;

  .task-date {
    white-space: nowrap;
    margin-right: 10px;
  }

  .task-name {
    margin-right: auto;
    cursor: pointer;
  }

  .task-time {
    margin-right: 5px;
  }

  .task-timer-btn {
    margin: 0;
  }
}

.hovering {
  /*background: rgba(210, 210, 210, 0.9);*/
  border: 1px dashed gray;
  cursor: copy;
}

.upcoming-tasks-box {
  margin-top: 30px;
  .upcoming-tasks-row {
    width: 100%;
    padding-left: 20px;
    cursor: pointer;
  }
  h4 {
    cursor: pointer;
    margin-top: 10px;
  }
}

.bottom-bar-headline {
  color: #ffffff;
}

.btn {
  cursor: pointer;

  &.tree {
    padding: 0;
  }

  &.drag {
    cursor: move;
  }
}

::v-deep .v-calendar-weekly__day {
  &.v-present {
    .v-calendar-weekly__day-label {
      border: none;
    }

    .marker {
      border-radius: 50%;
      border: 1px solid currentColor;
      width: 32px;
      height: 32px;
    }
  }
  .v-calendar-weekly__day-label {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 5px;
  }
}

::v-deep .v-treeview > .v-treeview-node--leaf {
  margin-left: 0;
}

::v-deep .v-treeview-node__content {
  flex-shrink: 1;
  max-width: 100%;
  .v-treeview-node__label {
    flex-shrink: 1;
    max-width: 100%;
  }
}

::v-deep .v-treeview-node--leaf {
  margin-left: 25px;
}

::v-deep .v-rating {
  white-space: nowrap;
}

.location-link {
  text-decoration: none;
  .v-icon {
    padding: 0;
  }
}

.root-drop-zone {
  width: 100%;
  height: 50px;
  border: 1px dashed gray;
}

.calendar-rating-placeholder {
  height: 32px;
  display: flex;
  align-items: center;
}

.markdown {
  ::v-deep {
    h1, h2, h3, h4, h5, h6 {
      font-weight: 300;
    }
    code[class*="language-"], pre[class*="language-"] {
      border: none;
      box-shadow: none;
    }
  }
}

.task-notes-container {
  font-size: 0.95rem;

}


</style>
